// Centralised dashboard IDs file
// Replace placeholder values with your actual Superset dashboard IDs (strings or numbers as required).

// Main dashboards
export const main_dashboard_id = 'REPLACE_MAIN_DASHBOARD_ID';
export const waltloo_dashboard_id = 'c9d9f4e2-0c04-4e62-8c01-4af5028054c4';
export const atteridgville_dashboard_id = '35c60269-4af4-4065-b07c-2a849fa2e852';
export const lesedi_dashboard_id = 'REPLACE_LESEDI_DASHBOARD_ID';

// Global dashboards
export const global_executive_dashboard_id = '295fb3f6-dd32-4d51-82b3-7b4914bab3d8';
export const global_financial_dashboard_id = '2c63353b-bd72-41e8-b14e-98685a218f45';
export const global_comparisons_dashboard_id = '63a58e47-9ab1-4efb-85bc-a857f94fdcca';
export const global_esg_dashboard_id = '70fe0d7e-484d-4156-aad6-cd7d7173396f';
export const global_fungi_profit_share_id = '1cd05591-e630-4735-b943-801f1575b119';

// Property-level universal dashboards (fallbacks)
export const property_operations_dashboard_id = '63641859-234b-461c-86f7-2041c8acf64a';
export const property_utilities_dashboard_id = 'REPLACE_PROPERTY_UTILITIES_DASHBOARD_ID';
export const property_parking_dashboard_id = 'REPLACE_PROPERTY_PARKING_DASHBOARD_ID';
export const property_security_dashboard_id = 'REPLACE_PROPERTY_SECURITY_DASHBOARD_ID';
export const property_analytics_dashboard_id = 'REPLACE_PROPERTY_ANALYTICS_DASHBOARD_ID';
export const property_resources_dashboard_id = 'REPLACE_PROPERTY_RESOURCES_DASHBOARD_ID';
export const property_savings_insights_dashboard_id = '92de10ae-f793-4445-a2d4-0cf45adfe4a7';

// Property-specific dashboards (per-property overrides)
// Keep the same keys used by `dashboard_one.js` for automatic compatibility.
export const property_specific_dashboards = {
  'Grupo Antolin (Waltloo)': {
    'executive-summary': waltloo_dashboard_id,
    'operations-overview': '63641859-234b-461c-86f7-2041c8acf64a',
    'utilities': '9c267134-0374-4723-8592-31c9fe4ca8d7',
    'energy': 'ce26a571-9d35-4d86-9d7a-8c883ee19bdc',
    'parking-access': '9353a854-fc92-491b-a700-3e26b732072c',
    'security': '0d65e04b-4c52-4121-8306-a38a16ddf0ba',
    'connectivity': '12d1bfba-80b4-46f2-9a0a-6ea4ada0ea51',
    'insights-analytics': '6ad331b7-787e-4f08-86af-dbcf8e8d55c0',
    'resources': 'REPLACE_LESEDI_RESOURCES_DASHBOARD_ID'
  },

  'Atteridgville Waste Center': {
    'executive-summary': atteridgville_dashboard_id,
    'operations-overview': '63641859-234b-461c-86f7-2041c8acf64a',
    'utilities': '595ee578-f868-43fa-badd-20149ed21630',
    'energy': '46e5dfb9-5a4f-4cae-aae6-366b35316f00',
    'parking-access': '9565f2be-70a8-48b1-8fe6-d2c8eb1b0a28',
    'security': '29e46721-d0f9-4f7a-8f2d-6ce49084825d',
    'connectivity': 'ded08b79-145d-4110-82f5-0a6ef7354fac',
    'insights-analytics': 'd8e4b006-876c-40bc-98cc-9102f13268c5',
    'resources': 'REPLACE_EKUPHUMLENI_RESOURCES_DASHBOARD_ID'
  },

  'Rivergate City Shopping Centre': {
    'executive-summary': lesedi_dashboard_id,
    'operations-overview': '63641859-234b-461c-86f7-2041c8acf64a',
    'utilities': 'b9590404-5fd8-4584-b9f1-84f0a92b4d3a',
    'energy': '634ca7df-5eb8-4106-ae41-4b8e84d6393c',
    'parking-access': 'bf38a202-2c00-42b8-92a7-e0e8c6926e37',
    'security': '66e3783b-056a-4d8e-939e-37e97da47698',
    'connectivity': '0a36e130-3286-438f-a1f8-18851ff08c8a',
    'insights-analytics': 'b542386e-058f-483e-8937-60ff4fe664ca',
    'savings_insights': 'da412463-f60b-47f0-9a62-470fd60359e4',
    'resources': 'REPLACE_RIVERGATE_RESOURCES_DASHBOARD_ID'
  }
};

// A fallback mapping used in the dashboard component
export const property_dashboards = {
  'executive-summary': null,
  'operations-overview': property_operations_dashboard_id,
  'utilities': property_utilities_dashboard_id,
  'energy': property_utilities_dashboard_id,
  'parking-access': property_parking_dashboard_id,
  'security': property_security_dashboard_id,
  'connectivity': property_security_dashboard_id,
  'insights-analytics': property_analytics_dashboard_id,
  'savings_insights': property_savings_insights_dashboard_id,
  'resources': property_resources_dashboard_id
};

// You can export a single default object if preferred by other modules:
export default {
  main_dashboard_id,
  waltloo_dashboard_id,
  atteridgville_dashboard_id,
  lesedi_dashboard_id,
  global_executive_dashboard_id,
  global_financial_dashboard_id,
  global_comparisons_dashboard_id,
  global_esg_dashboard_id,
  global_fungi_profit_share_id,
  property_operations_dashboard_id,
  property_utilities_dashboard_id,
  property_parking_dashboard_id,
  property_security_dashboard_id,
  property_analytics_dashboard_id,
  property_resources_dashboard_id,
  property_savings_insights_dashboard_id,
  property_specific_dashboards,
  property_dashboards
};

